module.exports = __webpack_public_path__ + "static/carusel-qrqode-e318ed97f6ba2151caea25b38623f1f4.webp";